import { Button, Card, Result } from 'antd';
import {
  usePermissions,
  useCurrentUser
} from 'client/components/auth/AuthModule';
import { LoaderSpin } from 'client/ui/loader/LoaderSpin';
import { ProcedureLinkText } from 'client/ui/naming/ProcedureLinkText';
import { IProcedure } from 'common/schema/Procedure';
import { IRequest, RequestState } from 'common/schema/request/Request';
import { UserLogic } from 'common/schema/UserLogic';
import moment from 'moment';
import * as React from 'react';
import { Link } from 'react-router-dom';

export interface IRequestProcessingMessageProps {
  procedure: IProcedure;
  request: IRequest;
}

export function RequestProcessingMessage(
  props: IRequestProcessingMessageProps
) {
  const { request, procedure } = props;
  const permissions = usePermissions();
  const user = useCurrentUser();

  // Testo di invio a email
  const recipientMail = UserLogic.recipientMailForRequest(
    user?.citizen,
    request
  );
  const emailNotificationContent = recipientMail && (
    <>all'indirizzo {recipientMail}.</>
  );

  return (
    <Card className="request-send-success-message">
      <Result
        status="info"
        title={
          request.state === RequestState.Sending
            ? 'Invio della domanda in corso...'
            : 'La tua domanda è stata presa in carico'
        }
        subTitle={
          <>
            Gentile utente, l’istanza risulterà correttamente acquisita soltanto
            al momento della ricezione dei dati di protocollo
            {emailNotificationContent}. Qualora non dovesse ricevere la mail, La
            preghiamo di contattare l’indirizzo mail del supporto tecnico.
          </>
        }
        extra={[
          <>
            {permissions.has('request.read:own') && (
              <Link to={`/richieste/istanze`}>
                <Button type="primary" key="logged">
                  Le mie Istanze
                </Button>
              </Link>
            )}
          </>,
          <Link to={`/domande/${procedure.id}`}>
            <Button key="procedure">{ProcedureLinkText}</Button>
          </Link>
        ]}
      />
    </Card>
  );
}
